<nav>
  <div class="btn-back" [class.hidden]="backHidden" (click)="back.emit()">
    <a class="rounded-btn-prev" role="button"></a>
    <span class="back">Back</span>
  </div>

  <div
    class="btn-next"
    [class.disabled]="nextDisabled"
    [class.hidden]="nextHidden"
    (click)="!nextDisabled && next.emit()"
  >
    Next
  </div>
</nav>
